/**
 * Formata o tipo de quitação da parcela para exibição legível
 * Ex: 'T' => 'Total', 'P' => 'Parcial'
 * @param value - Código do tipo de quitação
 * @returns Descrição legível do tipo de quitação
 */
export const parcelaTipoQuitacaoFormat = (value: string): string => {
  if (!value) return '-';

  const tipoQuitacaoMap: Record<string, string> = {
    'T': 'Total',
    'P': 'Parcial',
  };

  return tipoQuitacaoMap[value] || value;
};
